import { action } from 'typesafe-actions';

import { MediaUpdateDto, MessageType } from '@models';
import { MediaDto } from '@models/media/MediaDto';

import { Zone } from '../../zone/duck/types';
import { ActionTypes, FolderPathItem, MessageLibraryItem } from './types';

export const addMessages = (messageType: MessageType, medias: MediaDto[]) =>
  action(ActionTypes.ADD_MESSAGES, { messageType, medias });
export const createMediaRequest = (messageType: MessageType, media: MediaUpdateDto) =>
  action(ActionTypes.CREATE_MEDIA_REQUEST, { messageType, media });
export const createMediaSuccess = (messageType: MessageType, media: MediaDto) =>
  action(ActionTypes.CREATE_MEDIA_SUCCESS, { messageType, media });

export const pushFolder = (folder: MessageLibraryItem) => action(ActionTypes.PUSH_FOLDER, { folder });
export const popFolder = (folderPathItem?: FolderPathItem) => action(ActionTypes.POP_FOLDER, { folderPathItem });
export const resetRootFolder = (messageType: MessageType) => action(ActionTypes.RESET_ROOT_FOLDER, { messageType });

export const fetchLibraryRequest = (workgroupId: number) => action(ActionTypes.FETCH_LIBRARY_REQUEST, { workgroupId });

export const fetchLibrarySuccess = (workgroupId: number, messages: MessageLibraryItem[], messageType: MessageType) =>
  action(ActionTypes.FETCH_LIBRARY_SUCCESS, {
    workgroupId,
    messages,
    messageType,
  });

export const fetchMessageInfoRequest = (id: number) => action(ActionTypes.FETCH_MESSAGE_INFO_REQUEST, { id });

export const fetchMessageInfoSuccess = (message: MediaDto, referencedChannels: Zone[]) =>
  action(ActionTypes.FETCH_MESSAGE_INFO_SUCCESS, { message, referencedChannels });

export const deleteMessagesRequest = (mediaIds: number[]) => action(ActionTypes.DELETE_MESSAGES_REQUEST, { mediaIds });

export const deleteMessagesSuccess = (mediaIds: number[]) => action(ActionTypes.DELETE_MESSAGES_SUCCESS, { mediaIds });

export const saveMessagesRequest = (message: MediaUpdateDto) =>
  action(ActionTypes.SAVE_MESSAGE_INFO_REQUEST, { message });

export const saveMessagesSuccess = (message: MediaUpdateDto) =>
  action(ActionTypes.SAVE_MESSAGE_INFO_SUCCESS, { message });

export const selectLibraryItem = (mediaId: number) => action(ActionTypes.SELECT_LIBRARY_ITEM, mediaId);

export const clearLibrarySelection = () => action(ActionTypes.CLEAR_LIBRARY_SELECTION);

export const selectMediaAddressingChannel = (mediaId: number, zoneId: number) =>
  action(ActionTypes.SELECT_MEDIA_ADDRESSING_CHANNEL, { mediaId, zoneId });
